module.exports = __webpack_public_path__ + "static/media/10-10.762b6012.mp3";